import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useI18n } from 'builder/hooks/useI18n'

import LOADING_GIF from '../assets/loading.gif'
import { Container, Image, Text } from './styles'

export const Loading = () => {
  const { i18n } = useI18n()
  const navigate = useNavigate()

  useEffect(() => {
    setTimeout(() => {
      navigate(`/provision-users/onboarding`)
    }, 3000)
  }, [navigate])

  return (
    <Container>
      <Image src={LOADING_GIF} />
      <Text>{i18n.t('builder.provision_users.loading.title')}</Text>
    </Container>
  )
}
